import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems
} from '@headlessui/react'
import {useAuth} from "@workos-inc/authkit-react";
import {useNavigate} from "react-router-dom";
import React, {useEffect} from "react";
import {getUserId, logOutSession} from "../../requests/AppSession";
import {deleteUser, findUserVirtualTipz} from "../requests/AppRequestCustomerUser";

import {CheckIcon, XCircleIcon} from "@heroicons/react/20/solid";
import {ExclamationTriangleIcon, XMarkIcon} from '@heroicons/react/24/outline'
import {CardGridSkeleton} from "./VTSkeletons";

export default function VTUserVirtualTipz() {

    const {isLoading, getAccessToken} = useAuth();

    let navigate = useNavigate();

    const [userId, setUserId] = React.useState(null);

    const [virtualTipz, setVirtualTipz] = React.useState(null);

    const [errorMessage, setErrorMessage] = React.useState(null);

    const [openErrorMessage, setOpenErrorMessage] = React.useState(false);

    const [open, setOpen] = React.useState(false);

    const [openDeleteSuccess, setOpenDeleteSuccess] = React.useState(false);

    useEffect(() => {
        getUserId().then(userIdSession => {
            if (userIdSession) {
                setUserId(userIdSession);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })

        return function cleanup() {

        };
    }, [isLoading]);

    const getSuccess = async responseJson => {
        if (
            responseJson
        ) {
            if (responseJson.length > 0) {
                setVirtualTipz(responseJson)
            } else {
                setVirtualTipz([]);
            }
        } else {
            setErrorMessage("Error accessing user tip history, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setErrorMessage("Error accessing user tip history, please refresh and verify Internet Connection.");
    };

    const getDeleteSuccess = async responseJson => {
        if (
            responseJson && responseJson.error
        ) {
            setErrorMessage(responseJson.message);
            setOpen(false);
            setOpenErrorMessage(true);
        } else if (responseJson && responseJson.message) {
            setOpenDeleteSuccess(true);
            await logOutSession();
            navigate('/login/mobile');
        } else {
            setErrorMessage("Error accessing venue dates, please refresh and verify Internet Connection.");
            setOpen(false);
            setOpenErrorMessage(true);
        }
    };

    const getDeleteError = forceLogout => {
        setErrorMessage("Error deleting account, please refresh and verify Internet Connection.");
        setOpen(false);
        setOpenErrorMessage(true);
    };

    useEffect(() => {
        if (!isLoading && userId !== null) {
            findUserVirtualTipz(userId, getSuccess, getError, getAccessToken);
        }
        return function cleanup() {

        };
    }, [isLoading, userId]);

    return (
        <>
            <div className="bg-white dark:bg-gray-900">
                <div className="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8 lg:pb-24">
                    {!virtualTipz && <CardGridSkeleton/>}
                    <ul role="list" className="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
                        {virtualTipz && virtualTipz.map((client) => (
                            <li key={client.venueId} className="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700">
                                <div className="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 dark:bg-gray-800 p-6">
                                    <img
                                        alt={client.venueName}
                                        src={"../../" + client.venueImgFileName}
                                        className="h-8 flex-none rounded-lg object-cover"
                                    />
                                    <div className="text-sm/6 font-medium text-gray-900 dark:text-gray-100">{client.venueName}</div>
                                    <Menu as="div" className="relative ml-auto">
                                        <MenuButton className="relative block text-gray-400 dark:text-gray-500 hover:text-gray-500">
                                            <span className="absolute -inset-2.5"/>
                                            <span className="sr-only">Open options</span>
                                            {/*<EllipsisHorizontalIcon aria-hidden="true" className="size-5"/>*/}
                                        </MenuButton>
                                        <MenuItems
                                            transition
                                            className="absolute right-0 z-10 mt-0.5 w-32 origin-top-right rounded-md bg-white dark:bg-gray-800 py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                                        >
                                            <MenuItem>
                                                <a
                                                    href="#"
                                                    className="block px-3 py-1 text-sm/6 text-gray-900 dark:text-gray-100 data-focus:bg-gray-50 dark:data-focus:bg-gray-800 data-focus:outline-hidden"
                                                >
                                                    View<span className="sr-only">, {client.venueName}</span>
                                                </a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a
                                                    href="#"
                                                    className="block px-3 py-1 text-sm/6 text-gray-900 dark:text-gray-100 data-focus:bg-gray-50 dark:data-focus:bg-gray-800 data-focus:outline-hidden"
                                                >
                                                    Edit<span className="sr-only">, {client.venueName}</span>
                                                </a>
                                            </MenuItem>
                                        </MenuItems>
                                    </Menu>
                                </div>
                                <dl className="-my-3 divide-y divide-gray-100 dark:divide-gray-700 px-6 py-4 text-sm/6">
                                    <div className="flex justify-between gap-x-4 py-3">
                                        <dt className="text-gray-500 dark:text-gray-400">VT Amount Remaining</dt>
                                        <dd className="flex items-start gap-x-2">
                                            <div className="font-medium text-gray-900 dark:text-gray-100">
                                                {client.virtualTips} VT
                                            </div>
                                            {/*<div*/}
                                            {/*    className={classNames(*/}
                                            {/*        statuses[client.lastInvoice.status],*/}
                                            {/*        'rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',*/}
                                            {/*    )}*/}
                                            {/*>*/}
                                            {/*    {client.lastInvoice.status}*/}
                                            {/*</div>*/}
                                        </dd>
                                    </div>
                                    <div className="flex justify-between gap-x-4 py-3">
                                        <dt className="text-gray-500 dark:text-gray-400">Last visit</dt>
                                        <dd className="text-gray-700 dark:text-gray-200">
                                            {/*<time dateTime={client.lastInvoice.dateTime}>{client.lastInvoice.date}</time>*/}
                                            {client.lastVisit && <span
                                                className="text-gray-900 dark:text-gray-100">{new Date(client.lastVisit).toLocaleDateString('en-US', { 
                                                    year: 'numeric', 
                                                    month: 'long', 
                                                    day: 'numeric' 
                                                })}</span>}
                                        </dd>
                                    </div>
                                </dl>
                            </li>
                        ))}
                    </ul>

                    {virtualTipz && virtualTipz.length === 0 &&
                        <>
                            <main className="grid min-h-full place-items-center bg-white dark:bg-gray-900 px-6 py-3 sm:py-4 lg:px-8">
                                <div className="text-center">
                                    <p className="text-base font-semibold text-pink-600">No VirtualTipz Purchased</p>
                                    <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 dark:text-gray-100 sm:text-7xl">
                                        You have not purchased any VirtualTipz
                                    </h1>
                                    <p className="mt-6 text-lg font-medium text-pretty text-gray-500 dark:text-gray-400 sm:text-xl/8">
                                        Visit a venue and purchase VirtualTipz
                                    </p>
                                    <div className="mt-10 flex items-center justify-center gap-x-6">
                                        <a
                                            onClick={() => {
                                                navigate('/find');
                                            }}
                                            className="rounded-md cursor-pointer bg-pink-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-pink-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                        >
                                            Check-in Club
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/user/buy/history');
                                            }}
                                            className="text-sm cursor-pointer font-semibold text-gray-900 dark:text-gray-100">
                                            See your Purchase History <span aria-hidden="true">&rarr;</span>
                                        </a>
                                    </div>
                                </div>
                            </main>
                        </>
                    }

                </div>

                <div className="flex items-center justify-center border-t border-gray-100 dark:border-gray-700 pt-12">
                    <button type="button"
                            className="text-xs font-semibold leading-6 text-red-600 hover:text-red-500"
                            onClick={() => {
                                setOpen(true);
                            }}
                    >
                        <span aria-hidden="true">-</span> Delete Account
                    </button>
                </div>
            </div>

            <Dialog open={openErrorMessage} onClose={setOpenErrorMessage} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95"
                        >
                            <div>
                                <div
                                    className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
                                    <XCircleIcon aria-hidden="true" className="size-6 text-red-600"/>
                                </div>
                                <div className="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="h3" className="text-base font-semibold text-gray-900 dark:text-gray-100">
                                        Delete Account Failed
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            {errorMessage}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-6">
                                <button
                                    type="button"
                                    onClick={() => setOpenErrorMessage(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-pink-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                >
                                    Ok
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95"
                        >
                            <div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
                                <button
                                    type="button"
                                    onClick={() => setOpen(false)}
                                    className="rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                                >
                                    <span className="sr-only">Close</span>
                                    <XMarkIcon aria-hidden="true" className="size-6"/>
                                </button>
                            </div>
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                                    <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600"/>
                                </div>
                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold text-gray-900 dark:text-gray-100">
                                        Delete account
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Are you sure you want to delete your account? All of your data will be
                                            permanently removed
                                            forever. This action cannot be undone.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    onClick={() => {
                                        deleteUser(userId, getDeleteSuccess, getDeleteError, getAccessToken);
                                    }}
                                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 sm:ml-3 sm:w-auto"
                                >
                                    Delete Account
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setOpen(false)}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-xs ring-1 ring-gray-300 dark:ring-gray-600 ring-inset hover:bg-gray-50 dark:hover:bg-gray-800 sm:mt-0 sm:w-auto"
                                >
                                    Cancel
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            <Dialog open={openDeleteSuccess} onClose={setOpenDeleteSuccess} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95"
                        >
                            <div>
                                <div
                                    className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                                    <CheckIcon aria-hidden="true" className="size-6 text-green-600"/>
                                </div>
                                <div className="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="h3" className="text-base font-semibold text-gray-900 dark:text-gray-100">
                                        Delete Account Successful
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500 dark:text-gray-400">

                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-6">
                                <button
                                    type="button"
                                    onClick={() => setOpenDeleteSuccess(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Ok
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
